import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '../../../../../types/product.js';
import { isSinglePurchase, isInStoreSubscriptionPurchase } from '../../../../../types/typeguards.js';
import { BookAppointmentCTA } from '../../../components/CTAs/BookAppointmentCTA/BookAppointmentCTA.js';
import { FindAStoreCTA } from '../../../components/CTAs/FindAStoreCTA/FindAStoreCTA.js';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/carts-v2';
import { useGetPriceSegment } from '../../../hooks/use-get-price-segment.js';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/utils';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/elements';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '../../../../../hooks/use-product-view-history.js';
import 'classnames';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/analytics';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../slots/context.js';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { CLAddToCartCTA } from './components/CLAddToCartCTA/CLAddToCartCTA.js';
import { DummyAddToCartCTA } from './components/DummyAddToCartCTA/DummyAddToCartCTA.js';

const ContactLensesCTA = ({ className  })=>{
    const { isContactLensEnabled  } = useFeatureToggles();
    const { routes , activeVariant  } = useProductData();
    const { priceSegment  } = useGetPriceSegment();
    const storesRoute = routes.stores;
    const { state , selectors  } = useCLEcommContext();
    const [isConfiguratorValid] = selectors.isConfiguratorValid(state);
    const hasNonOrderableProduct = selectors.hasNonOrderableProduct(state);
    // Prevent adding to cart if there is any query error in any enabled column
    const lineItemDrafts = selectors.getLineItemDrafts(state, isSinglePurchase(state.configurations.purchaseType) ? priceSegment : undefined);
    if (isInStoreSubscriptionPurchase(state.configurations.purchaseType)) {
        return /*#__PURE__*/ React.createElement(BookAppointmentCTA, {
            className: className,
            href: storesRoute
        });
    }
    if (activeVariant.isExcludedFromCheckout || hasNonOrderableProduct) {
        return /*#__PURE__*/ React.createElement(FindAStoreCTA, {
            className: className,
            href: storesRoute
        });
    }
    if (!isContactLensEnabled) {
        return /*#__PURE__*/ React.createElement(BookAppointmentCTA, {
            className: className,
            href: storesRoute
        });
    }
    if (isContactLensEnabled && isConfiguratorValid && lineItemDrafts.length > 0) {
        return /*#__PURE__*/ React.createElement(CLAddToCartCTA, {
            className: className,
            lineItemDrafts: lineItemDrafts
        });
    }
    return /*#__PURE__*/ React.createElement(DummyAddToCartCTA, {
        className: className
    });
};

export { ContactLensesCTA };
//# sourceMappingURL=ContactLensesCTA.js.map
